import { MARKET, PLAN } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { ESTabsLayout } from './ESTabsLayout';
import { ITTabsLayout } from './ITTabsLayout';
import { PTTabsLayout } from './PTTabsLayout';

export function TabsLayout() {
  const { company } = useEmployeeDetails();

  if (company.market.slug === MARKET.PT) {
    return <PTTabsLayout plan={company.settings?.plan ?? PLAN.SUC_MEAL} />;
  }

  if (company.market.slug === MARKET.IT) {
    return <ITTabsLayout plan={company.settings?.plan ?? PLAN.ITALY} />;
  }

  if (company.market.slug === MARKET.ES) {
    return <ESTabsLayout plan={company.settings?.plan ?? PLAN.ES_MEAL} />;
  }

  return null;
}
